import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { JitsiMeeting } from "@jitsi/react-sdk";
import { ArrowLeft } from "@phosphor-icons/react";
import api, { formatApiError } from "../lib/api";
import { fmtMeetingTime } from "../components/MyMeetingsCard";

export default function MeetingRoomPage() {
  const { mid } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/meetings/${mid}/join`).then((r) => setInfo(r.data)).catch((e) => setErr(formatApiError(e)));
  }, [mid]);

  return (
    <div className="mx-auto max-w-5xl" data-testid="meeting-room-page">
      <button onClick={() => navigate("/meetings")} className="mb-4 inline-flex items-center gap-1 text-sm text-stone-500 hover:text-stone-900" data-testid="meeting-room-back">
        <ArrowLeft size={14} /> Back to meetings
      </button>
      {err && (
        <div className="rounded-xl border border-[#C0392B]/30 bg-[#C0392B]/5 p-6 text-sm text-[#C0392B]" data-testid="meeting-room-error">{err}</div>
      )}
      {!info && !err && (
        <div className="flex justify-center py-24" data-testid="meeting-room-loading">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        </div>
      )}
      {info && (
        <>
          <h1 className="font-heading text-2xl font-semibold tracking-tight text-stone-900" data-testid="meeting-room-title">{info.title}</h1>
          <p className="mb-4 mt-1 text-sm text-stone-500" data-testid="meeting-room-when">
            {fmtMeetingTime(info.start_at)} · about {info.duration_minutes} minutes · your camera & mic stay in your browser
          </p>
          <div className="h-[72vh] overflow-hidden rounded-2xl border border-stone-200 shadow-sm" data-testid="meeting-room-frame">
            <JitsiMeeting
              domain="meet.jit.si"
              roomName={info.room_name}
              userInfo={{ displayName: info.display_name }}
              configOverwrite={{
                prejoinConfig: { enabled: true },
                startWithAudioMuted: true,
                startWithVideoMuted: false,
              }}
              onApiReady={(apiObj) => {
                apiObj.addListener("readyToClose", () => navigate("/meetings"));
              }}
              getIFrameRef={(node) => { if (node) node.style.height = "100%"; }}
            />
          </div>
        </>
      )}
    </div>
  );
}
